import { useEffect } from 'react';

const OG_LOCALES = { fr: 'fr_FR', en: 'en_GB', lv: 'lv_LV' };

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  const created = !el;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  const previous = el.getAttribute('content');
  el.setAttribute('content', content);
  return () => {
    if (created) el.remove();
    else if (previous !== null) el.setAttribute('content', previous);
  };
};

const upsertCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  const previous = el ? el.getAttribute('href') : null;
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
  return () => {
    if (previous) el.setAttribute('href', previous);
    else el.remove();
  };
};

// Runtime SEO / Open Graph tags for a routed page (single-page app)
export const useSeo = ({ title, description, url, image, imageAlt, language, type = 'article' }) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    const restores = [
      upsertMeta('name', 'description', description),
      upsertMeta('property', 'og:type', type),
      upsertMeta('property', 'og:url', url),
      upsertMeta('property', 'og:title', title),
      upsertMeta('property', 'og:description', description),
      upsertMeta('property', 'og:image', image),
      upsertMeta('property', 'og:image:alt', imageAlt),
      upsertMeta('property', 'og:locale', OG_LOCALES[language] || 'fr_FR'),
      upsertMeta('name', 'twitter:card', 'summary_large_image'),
      upsertMeta('name', 'twitter:title', title),
      upsertMeta('name', 'twitter:description', description),
      upsertMeta('name', 'twitter:image', image),
      upsertCanonical(url),
    ];

    return () => {
      document.title = previousTitle;
      restores.forEach((restore) => restore());
    };
  }, [title, description, url, image, imageAlt, language, type]);
};

export default useSeo;
